export const CTA_URL_PATH = "/collections/service#contact";
